import './App.css';
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Footer from './Components/Footer/Footer';
import { useLocation } from "react-router-dom";
import Home from './Components/Home/Home';
import Navbar from './Components/Navbar/Navbar';
import Case from './Components/CaseResult/Case';
import Results from './Components/CaseResult/Results';
import AboutUs from './Components/Aboutus/Aboutus';
import ContactUs from './Components/Contactus/Contactus';
import PracticeArea from './Components/PracticeArea/PracticeArea';
import PracticeAreaDetail from './Components/PracticeArea/PracticeAreaDetail';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'  
    });
  }, [pathname]);

  return null;
}
function App() {
  return (
    <Router>
      <Navbar />
       <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
         <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/case-studies" element={<Case />} />
        <Route path="/case-studies/:id" element={<Results />} />
         <Route path="/practicearea" element={<PracticeArea />} />
         <Route path="/practicearea/:id" element={<PracticeAreaDetail />} />
         <Route path="/contactus" element={<ContactUs />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
